module.exports = __webpack_public_path__ + "static/fib-video-preview-4cf647abf6e0906bf61c4f3e5eb58ae7.jpg";